<template>
  <div>
    <section class="section bg-secondary">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6">
            <div class="card bg-default shadow border-0">
              <figure class="walden">
                <router-link to="/contact">
                  <img v-lazy="'img/stock/sven-mieke-1163015-unsplash.jpg'" class="card-img-top">
                </router-link>
              </figure>
              <blockquote class="card-blockquote">
                  <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95" class="svg-bg">
                    <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                    <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                  </svg>
                <h4 class="display-3 font-weight-bold text-white">Whole Life Solutions</h4>
                <p class="lead text-italic text-white">Your peace of mind is priceless. Don't spend your retirement worried about money. Forward Financial will help you plan a future full of peaceful days and lasting memories.</p>
              </blockquote>
            </div>
          </div>
          <div class="col-md-6">
            <div class="pl-md-5 text-default">
              <h1 class="display-2">Free Consultation</h1>
              <p class="lead">Contact Forward Financial today for your free consultation.</p>
              <p>Our team is standing by help you plan a better future. In your free consultation, we will review your goals, resources, and immediate needs, and build a strategy together for taking the steps to make your dream a reality.</p>
              <b-button to="/contact" variant="default" class="floating">Schedule Your Free Consultation Today</b-button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {}
</script>
